<div class="main-container user-profile-container">
  <form class="user-profile-form form-group-container" novalidate #form="ngForm" name="updateEmailForm"
    [formGroup]="updateEmailForm" (ngSubmit)="onSubmitUpdateEmail(updateEmailForm.value)"
    [ngClass]="{submitted: formSubmitted}">
    <p style='margin: 0 0 10px 0; font-size: 15px; line-height: 1.5;display: block; margin-block-start: 1em; margin-block-end: 1em; margin-inline-start: 0px; margin-inline-end: 0px; text-align: center;'>
      <!-- Are you sure you want to update your email? <br> -->
      Do you wish to update your email? <br>
      A valid Solenis email ID is required for the new email.
    </p>

    <!-- <label class="form-control-container">
    <div class="control-label">Current {{'email' | translate}}</div>
    <div class="control-input-container">
      <input class="control-input" type="text" id="email" name="email" placeholder="Please enter your current email ID" formControlName="email"
        required>
      <div *ngIf="email.invalid || (email.dirty || email.touched)" class="control-error-container error-msgs">

      </div>
    </div>
  </label> -->
  <label class="form-control-container">
    <div class="control-label">New {{'email' | translate}}</div>
    <div class="control-input-container">
      <input class="control-input" type="text" id="email" name="email" placeholder="Please enter your new solenis email ID" formControlName="new_email"
        required>
      @if (email.invalid || (email.dirty || email.touched)) {
        <div class="control-error-container error-msgs">
        </div>
      }
    </div>
  </label>
  <div class="submission_message"> After submitting, you will receive an email link to proceed with the email update.</div>

  <div class="form-submit-container">
    <button class="btn" [ngClass]="{'submit-btn-disabled': updateEmailForm.invalid}" type="submit"> Submit </button>
  </div>

</form>
@if (loader) {
  <div class="site-loader-wrapper grey-bg-loader">
    <div class="loader"></div>
  </div>
}
</div>